import { isNullIndex } from "./planUtils";

export function getRenderKey(object: { id?: number }, index: number) {
  return isNullIndex(object?.id) ? `new-${index}` : object.id;
}

export function getIndexRenderKey(index: number) {
  return `new-${index}`;
}
